export const ExcludeTenDays = () => {
  const ExcludedDays = new Date();
  return ExcludedDays.setDate(ExcludedDays.getDate() - 10);
};
